import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'

import MediaUpload from 'components/MediaUpload'
import { ScreenPicker } from '../../ScreenPicker'
import SharedSections from './SharedSections'

const Content = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <FieldLabel label='Image' labelFor='image'>
      <MediaUpload
        type='image'
        value={content.image || ''}
        maxHeight='100px'
        onUpload={onChange('image')}
        projectId={project?.meta?.id}
        path={`list-${screen?.meta?.name}-image`}
        withTextfield={true}
        disabled={disabled}
      />
    </FieldLabel>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <ScreenPicker
      screenName={screen?.meta?.name}
      screens={content.list}
      onChange={onChange('list')}
      disabled={disabled}
      multiple
    />
  )
}

export default [
  { label: 'Content', content: Content },
  { label: 'Child Screens', content: ChildScreens },
  ...SharedSections,
]
